const INFO = {
	main: {
		title: "Pavitra Agarwal Portfolio",
		name: "Pavitra Agarwal",
		email: "pavitra.agarwal21b@iiitg.ac.in",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://x.com/pavitra1agarwal",
		github: "https://github.com/PavitraAgarwal21",
		linkedin: "https://www.linkedin.com/in/pavitraagarwal16/",
		telegram: "https://t.me/blackpanther3000",
	},

	homepage: {
		title: "Blockchain Developer experience across Ethereum, Bitcoin and StarkNet",
		description:
"I am a Blockchain Developer with expertise in Ethereum, Bitcoin, and zero-knowledge proofs. I have experience building decentralized solutions that are secure, scalable, and accessible. Passionate about pushing the boundaries of blockchain technology, I enjoy tackling complex challenges and continuously expanding my skills. Committed to delivering high-quality code that adheres to best practices, I am always seeking new opportunities to innovate and grow in the blockchain space."
	},

	about: {
		title: "I’m Pavitra Agarwal . I live in Jhansi , Uttarpradesh,",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, blockchain , zero-knowledge ,scalblity , product design, and more.",
	},

	projects: [
		{
			title: "CCNFTS",
			description:"CCNFTs revolutionizes blockchain gaming by integrating classic games with NFTs, creating dynamic ON-NFT experiences. Players earn tokens and mint unique chessboards with each move, blending ERC20 and ERC721 tokens for a vibrant, interconnected economy.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/typescript/typescript.png",
			linkText: "View Project",
			link: "https://github.com/PavitraAgarwal21/CCNFTS",
		},

		{
			title: "ZKTPS",
			description:"Using zero-knowledge-based ticket checking on StarkNet reduces fees due to its zk-rollup scaling solution and ensures private, secure validation with SNARK proofs on STARK proof system starknet . This approach offers lower transaction costs and enhanced privacy compared to Ethereum mainnet.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/PavitraAgarwal21/ZKTPS",
		},

		{
			title: "ZKTP",
			description:"A zero-knowledge-based ticket checking protocol on Ethereum uses cryptographic proofs to verify ticket validity without revealing sensitive information. This ensures secure and private validation while preventing fraud.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/PavitraAgarwal21/ZKTP",
		},

		{
			title: "Bitcoin-from-scratch",
			description:
" the simulation of mining process of a block, which includes validating and including transactions from a given set of transactions.",
		logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/PavitraAgarwal21/bitcoin-from-scratch",
		},
		{
			title: "Token-Vesting-For-Organization",
			description:
			"Develop a Solidity and ethers.js DApp for token distribution in Web3 organizations, enabling ERC20 token creation with adjustable vesting schedules, admin registration, stakeholder management, and claiming .",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/PavitraAgarwal21/Token-Vesting-For-Organization",
		},
		{
			title: "AMM",
			description:"An Automated Market Maker (AMM) is a decentralized trading protocol that uses algorithms to set asset prices and facilitate trades through liquidity pools, ensuring continuous liquidity without a central authority.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/PavitraAgarwal21/AMM_ETH",
		},
	],
};

export default INFO;
